<template>
    <div class="mobile-banner" v-if="showBanner">
        <button class="mobile-banner__close" @click="closeClick">
            <SvgIcon name="close" :size="12" />
        </button>
        <img v-if="isIos" :src="config.iconApple" alt="Ikona mobilní aplikace" />
        <img v-else :src="config.iconAndroid" alt="Ikona mobilní aplikace" />
        <div class="mobile-banner__info">
            <div class="mobile-banner__name">{{ mainText }}</div>
            <div class="mobile-banner__subtext">{{ subText }}</div>
        </div>
        <a
            class="button button--primary button--size-s button--theme-yellow button--caps"
            href="#"
            :data-link="isIos ? config.buttonUrlApple : config.buttonUrlAndroid"
            :data-store="config.deepLinkStore"
            :data-app="config.deepLinkAndroid"
            @click="linkClick"
        >
            <div class="button__content">
                <span class="button__text">
                    {{ config.button }}
                </span>
            </div>
        </a>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import useIsBreakpoint from "@/shared/composables/use-is-breakpoint";
import { ResponsiveUtils } from "@/shared/utils/responsive-utils";
import { useCookieStorage } from "@/shared/composables/use-storage";

const { isMobileOrTablet } = useIsBreakpoint();
const { getItem, setItem } = useCookieStorage();

const isIos = ResponsiveUtils.isIos();
const isSafari = ResponsiveUtils.isSafari();

const storageKey = "mobile-banner-hidden";
const storageValue = "true";

const bannerClosed = ref(false);

const showBanner = computed(() => {
    return isMobileOrTablet() && !isSafari && getItem(storageKey) !== storageValue && !bannerClosed.value;
});

const closeClick = () => {
    bannerClosed.value = true;
    setItem(storageKey, storageValue, "essential", {
        expires: 2592000, // one month
    });
};

const config = {
    title: "Sazkabet",
    author: "Sazka a.s.",
    price: "Zdarma",
    suffixApple: " - v App Store",
    suffixAndroid: " ke stažení",
    iconApple: `${environment.sportBetsRootUrl}shared-img/header/app-icon.png`,
    iconAndroid: `${environment.sportBetsRootUrl}shared-img/header/app-icon.png`,
    button: "Stáhnout",
    buttonUrlApple: "https://apps.apple.com/cz/app/sazkabet/id1474630249",
    buttonUrlAndroid: "/mobilni-aplikace/sazkabet",
    deepLinkAndroid: "sazkabet://home",
    deepLinkStore: "1474630249",
};

const mainText = `Mobilní aplikace ${config.title}`;

const subText = `${config.price}${isIos ? config.suffixApple : config.suffixAndroid}`;

const linkClick = (event: MouseEvent) => {
    event.preventDefault();
    window.location = config.deepLinkAndroid as string & Location;
    setTimeout(() => {
        window.location = isIos
            ? (config.buttonUrlApple as string & Location)
            : (config.buttonUrlAndroid as string & Location);
    }, 500);
};
</script>
